import { render } from "./RewardButton.vue?vue&type=template&id=d7135050&scoped=true"
import script from "./RewardButton.vue?vue&type=script&lang=js"
export * from "./RewardButton.vue?vue&type=script&lang=js"

import "./RewardButton.vue?vue&type=style&index=0&id=d7135050&lang=less&scoped=true"
import "./RewardButton.vue?vue&type=style&index=1&id=d7135050&lang=less"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d7135050"]])

export default __exports__